var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconVehicle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 66.9,
    height: 48.655,
    viewBox: "0 0 66.9 48.655",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Pfad_17",
    "data-name": "Pfad 17",
    d: "M176.777,19.664h-9.123V7.5H125.082A6.1,6.1,0,0,0,119,13.582v33.45h6.082a9.123,9.123,0,0,0,18.246,0h18.246a9.123,9.123,0,0,0,18.246,0H185.9v-15.2ZM134.2,51.593a4.561,4.561,0,1,1,4.561-4.561A4.555,4.555,0,0,1,134.2,51.593Zm41.052-27.368,5.96,7.6H167.655v-7.6ZM170.7,51.593a4.561,4.561,0,1,1,4.561-4.561A4.555,4.555,0,0,1,170.7,51.593Z",
    transform: "translate(-119 -7.5)",
    fill: "#707070"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVehicle);
export default __webpack_public_path__ + "static/media/icon-vehicle.6ee16db7e686caece39bd95b76cfcb80.svg";
export { ForwardRef as ReactComponent };